/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { FormulaPropagationDialogConfig } from '@gh/builder-shared';
import { FormulaPropagationMode } from '@gh/builder-shared-data';
import { TranslationService } from '@gh/core-mls';
import { DialogInput } from '@gh/core-ui';

@Component({
  selector: 'gh-formula-propagation-dialog',
  template: require('./formula-propagation-dialog.component.html'),
  styles: [require('./formula-propagation-dialog.component.scss')],
})
export class FormulaPropagationDialogComponent implements OnInit, DialogInput<FormulaPropagationDialogConfig> {
  input: FormulaPropagationDialogConfig;

  formulaPropagationModeList: any = [{
    title: this.translationService.get('lbl_hp_all'),
    value: FormulaPropagationMode.All,
  }, {
    title: this.translationService.get('lbl_hp_selected'),
    value: FormulaPropagationMode.Selected,
  }];
  formula: string;
  code: string;
  selectedItem: any;

  get elementNameLabel(): string {
    return this.input.isComponent ? 'lbl_component' : 'lbl_item';
  }

  constructor(private dialogRef: MatDialogRef<any>,
              private translationService: TranslationService) {
  }

  ngOnInit(): void {
    this.formula = this.input && this.input.formula;
    this.code = this.input && this.input.elementCode;
    this.selectedItem = this.formulaPropagationModeList[0];
  }

  onPropagate(): void {
    this.dialogRef.close(this.selectedItem.value);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
